import GCBadge from "@/app/(site)/_components/Molecules/GCBadge"
import { type ImageElementType } from "@/gc-sanity-types"
import { type ResolvedBadge } from "@/src/utils/badges/types"
import { type ColorValue } from "@sanity/color-input"
import { type ReactNode } from "react"

interface SanityBadgeListProps {
    badges: ResolvedBadge[]
    className?: string
    children?: ReactNode
}

function toColorValue(hex: string | undefined): ColorValue | undefined {
    if (!hex) return undefined

    return { hex } as ColorValue
}

function toBadgeImage(url: string): ImageElementType {
    return { image: { asset: { url } } } as ImageElementType
}

export default function SanityBadgeList({
    badges,
    className,
    children
}: SanityBadgeListProps) {
    if (badges.length === 0) return null

    return (
        <div className={className}>
            {badges.map((badge, idx) =>
                badge.type === "image" && badge.image ? (
                    <GCBadge key={idx} badgeImage={toBadgeImage(badge.image)} />
                ) : (
                    <GCBadge
                        key={idx}
                        badgeText={badge.text}
                        textColor={
                            badge.textColor === "white"
                                ? "text-main-white"
                                : "text-main-black"
                        }
                        backgroundColor={toColorValue(badge.backgroundColor)}
                    />
                )
            )}
            {children}
        </div>
    )
}
